import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';

import styles from './SiteHeader.scss';
import Logo from './funbrain-logo.svg';
import ReadingIcon from './book-icon.svg';
import GamesIcon from './game-controller-icon.svg';
import VideosIcon from './video-player-icon.svg';
import TeachersAndParentsIcon from './whiteboard-teacher-icon.svg';
import MathIcon from './math-icon.svg';
import SearchIcon from './search-icon.svg';
import PlaygroundIcon from './playground-icon.svg';

import { withLocationWrapper } from '../../utils/HOC_LocationWrapper';

class SiteHeader extends Component {
  render() {
    return (
      <header className="SiteHeader">
        <div className="SiteHeader__content">
          <h1 className="SiteHeader__title">
            <NavLink to="/">
              <span
                style={{
                  color: 'white',
                  position: 'absolute',
                  top: '-100%',
                  left: '-100%',
                }}
              >
                Funbrain
              </span>
              <Logo className="SiteHeader__title-image" />
            </NavLink>
          </h1>
          <SiteNav {...this.props} />
        </div>
      </header>
    );
  }
}

class SiteNav extends Component {
  constructor() {
    super();
    this.state = {
      menuExpanded: false,
      items: [
        { label: 'Games', slug: 'games', icon: <GamesIcon /> },
        { label: 'Reading', slug: 'books', icon: <ReadingIcon /> },
        { label: 'Videos', slug: 'videos', icon: <VideosIcon /> },
        {
          label: 'Playground',
          slug: 'pre-k-and-k-playground',
          icon: <PlaygroundIcon />,
        },
        { label: 'Math Zone', slug: 'math-zone', icon: <MathIcon /> },
        // {label: 'Teachers + Parents', slug: 'teachers-and-parents', icon: <TeachersAndParentsIcon />},
        { label: 'Search', slug: 'search', icon: <SearchIcon /> },
      ],
    };
  }

  render() {
    const isALandingPageActive = items => {
      const activePathname = this.props.location.pathname;
      let isIt = false;
      items.map(item =>
        `/${item.slug}` === activePathname ? (isIt = true) : null
      );
      return isIt;
    };

    const items = this.state.items.map((item, i) => {
      return (
        <li className="SiteNav__item" key={'item-' + i}>
          <Link
            to={'/' + item.slug}
            className={'SiteNav__link for-' + item.slug}
            onClick={() => this.setState({ menuExpanded: false })}
            // activeClassName="is-active"
          >
            {item.icon}
            <label>{item.label}</label>
          </Link>
        </li>
      );
    });

    const activeLandingClass = isALandingPageActive(this.state.items)
      ? ' SiteNav--show-active'
      : '';
    return (
      <nav className={`SiteNav${activeLandingClass}`}>
        <button
          className="Button Button--menu"
          onClick={() => {
            this.setState({
              menuExpanded: !this.state.menuExpanded,
            });
          }}
        >
          {this.state.menuExpanded ? 'Hide' : 'Menu'}
        </button>
        <ul
          className={
            'SiteNav__list' + (this.state.menuExpanded ? ' is-expanded' : '')
          }
        >
          {items}
        </ul>
      </nav>
    );
  }
}

export default withLocationWrapper(SiteHeader);
